// Generated types for DiscreteAttribute
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { DiscreteKind } from '../enums';

import { AttributeReadAPI, AttributeWriteAPI } from './attribute';
import { AttributeReadAPISchemaObject, AttributeWriteAPISchemaObject } from './attribute';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface DiscreteAttributeReadAPI extends AttributeReadAPI {
  /** BOOLEAN / STRING / ENUM. ENUM constrains values to `enum_values`. */
  kind?: DiscreteKind;
  /** Allowed values when `kind=ENUM` (e.g. ['IP20','IP54','IP65','IP67']). */
  enum_values?: string[] | null;
  /** When `kind=ENUM`: if True, values outside `enum_values` are accepted (a freeform 'other...' option in the UI). Lets you publish a recommended set without forcing it. Default False — values must match `enum_values` exactly. */
  allow_other?: boolean;
}

export interface DiscreteAttributeWriteAPI extends AttributeWriteAPI {
  /** BOOLEAN / STRING / ENUM. ENUM constrains values to `enum_values`. */
  kind?: DiscreteKind;
  /** Allowed values when `kind=ENUM` (e.g. ['IP20','IP54','IP65','IP67']). */
  enum_values?: string[] | null;
  /** When `kind=ENUM`: if True, values outside `enum_values` are accepted (a freeform 'other...' option in the UI). Lets you publish a recommended set without forcing it. Default False — values must match `enum_values` exactly. */
  allow_other?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const DiscreteAttributeReadAPISchema: z.ZodType<DiscreteAttributeReadAPI> = AttributeReadAPISchemaObject.extend({
  kind: z.nativeEnum(DiscreteKind).optional(),
  enum_values: z.array(z.string()).nullable().optional(),
  allow_other: z.boolean().optional(),
}).passthrough();

export const DiscreteAttributeWriteAPISchema: z.ZodType<DiscreteAttributeWriteAPI> = AttributeWriteAPISchemaObject.extend({
  kind: z.nativeEnum(DiscreteKind).optional(),
  enum_values: z.array(z.string()).nullable().optional(),
  allow_other: z.boolean().optional(),
}).passthrough();
